import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { TeamsIcon } from '@atlaskit/temp-nav-app-icons/teams';

import { Products } from '../../constants';
import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function teams(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <TeamsIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		apsKey: Products.ATLAS_TEAMS,
		fallbackUrl,
	};
}
